import React, { useEffect, useRef, useState } from 'react';
import './HomeBgm.css';

export default function HomeBgm() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0.2);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const audio = audioRef.current;
    audio.volume = 0.2;
    return () => audio.pause();
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    const enable = audio.paused;
    if (enable) {
      setMessage('');
      audio.play().catch(() => setMessage('再生できませんでした。もう一度お試しください。'));
    } else {
      audio.pause();
    }
  };

  return (
    <section className="home-bgm" aria-label="教会のBGM">
      <audio
        ref={audioRef}
        src={`${process.env.PUBLIC_URL}/static/audio/untitled-2.mp3`}
        loop
        preload="none"
        onPlay={() => { setPlaying(true); setMessage(''); }}
        onPause={() => setPlaying(false)}
        onError={() => { setPlaying(false); setMessage('音源を読み込めませんでした。再度お試しください。'); }}
      />
      <div className="home-bgm__controls">
        <button type="button" onClick={toggle} aria-pressed={playing}
          aria-label={playing ? 'BGMを停止' : 'BGMを再生'}
          title={playing ? 'BGMを停止' : 'BGMを再生'}>
          <svg className="home-bgm__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            {playing ? (
              <><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></>
            ) : (
              <path d="M8 5.5 18 12 8 18.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            )}
          </svg>
        </button>
        <label>
          音量
          <input type="range" min="0" max="1" step="0.05" value={volume}
            onChange={(event) => {
              const next = Number(event.target.value);
              audioRef.current.volume = next;
              setVolume(next);
            }} />
        </label>
      </div>
      <p className="home-bgm__message" role="status">{message}</p>
    </section>
  );
}
